<script setup lang="ts">
import getAllAnnualReportsQuery from '@/graphql/getAllAnnualReports.gql'
import { ensureProtocol } from '~/helpers/urlHelpers'

const localePath = useLocalePath()
const { t, locale } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/financial-documents/annual-reports',
    'fr-CA': '/relations-avec-investisseurs/documents-financiers/rapport-annuel'
  }
})

useHead({
  title: t('navigation.annualReports.metatitle'),
  meta: [{ name: 'description', content: t('navigation.annualReports.metadescription') }]
})

const { execute: getAnnualReports } = useApolloFetch(getAllAnnualReportsQuery, 'annualReports')
const annualReports = await getAnnualReports({ locale: locale.value })

function getReportLabel(report: { Year: number, EnglishDocumentOnly: boolean }) {
  return `${t('annualReports.pdfLabel', { year: report.Year })}${report.EnglishDocumentOnly && locale.value === 'fr-CA' ? ' (Disponible en anglais seulement)' : ''}`
}

function getSizeInMB(size: number) {
  return (size / 1024).toFixed(2)
}
</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name')
              }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{
              $t('navigation.financialDocuments.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.annualReports.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.annualReports.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div class="GpcLibraryExplorer">
            <ul class="GpcLibraryExplorerWrapQueryList">
              <li v-for="report in annualReports"
                  :key="report.Year"
                  class="GpcLibraryExplorerWrapQueryListItem">
                <div class="LibraryExplorer_categoryQueryZone_9873204e6ee145339ced4b5af2a0bba3 LibraryExplorerCategoryQueryZone">
                  <div class="LibraryExplorer_categoryContentZone_8b8fde6bfce94f648ba4dd7452eab08e LibraryExplorerCategoryContentZone">
                    <div class="LibraryExplorer_categoryTitleZone_c6933b89d1bf4df0b8ef45febd73b215 LibraryExplorerCategoryTitleZone">
                      <span class="LibraryExplorerCategoryTitle">{{ report.Year }}</span>
                    </div>
                  </div>
                </div>
                <ul class="GpcLibraryExplorerWrapQueryList">
                  <li class="GpcLibraryExplorerWrapQueryListItem">
                    <div class="LibraryExplorer">
                      <div class="LibraryExplorer_resultContentZone_c7d37efd624c4051a3372fea465d4f4e LibraryExplorerResultContentZone">
                        <div class="LibraryExplorer_contentTitleZone_15bdbfbdceb3486c8b9d3e09dd7775de LibraryExplorerResultTitleZone">
                          <a class="LibraryExplorerResultTitle"
                             :href="ensureProtocol(report.Document.url)"
                             target="_blank">{{ getReportLabel(report) }}</a>
                        </div>
                        <div class="N8ff8c67c7514460088ce1c06f6a95afe separateur">
                          &nbsp;-&nbsp;
                        </div>
                        <div class="LibraryExplorer_contentFileSizeZone_71db956691194556a77e0a146c433822 LibraryExplorerResultFileSizeZone">
                          <span class="LibraryExplorerResultFileSize">{{ getSizeInMB(report.Document.size) }} Mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
